
<section class="content card">
  <app-location-detail-header
    [Location]="Location$ | async"
  ></app-location-detail-header>
</section>
